import React, { Component } from 'react';
import { Dimensions, View } from 'react-native';
import { articleItem, Flex, Helpers, Margin, Padding } from '../../styles/appStyles';
import apiHelpers from '../../utils/api-helpers';
import { helpers } from '../../utils/helpers';
import ArticleItemHorizontal from '../article-item-horizontal';
import ArticleItemLayoutHorizontal from '../article-item-layout-horizontal';
import ArticleItemUserStory from '../article-item-user-story';
import AuthenticationWrapper from '../authentication-wrapper';
import ScrollContainerView from '../scroll-container-view';

const windowWidth = Dimensions.get('window').width;

export class HomeRecentEdition extends Component {
    constructor(props) {
        super(props);
        let webView = helpers.isWeb();
        const { isAuthenticated, fetchToken } = this.props.auth
        let token = webView ? (process.browser ? (isAuthenticated ? fetchToken : false) : this.props.token) : this.props.user?.userData?.data?.token;
        this.state = {
            btnDisable: true,
            email: '',
            referralMsg: {
                enable: false,
                type: '', // error / success
                msg: ''
            },
            showToken: (!helpers.isWeb() || process.browser) ? true : false,
            data:false
        }
    }

    componentDidMount = () => {
        this.getNewsletterStories()
    }


    getNewsletterStories = () => {
        let { token, newsletterSlug, newsLetterDetails } = this.state;
       
        let endpoint = `/stories`;
        let body = {
            limit: 10,
            page: 1,
            sort_on: 'date',
            sort_by: 'desc',
            filters: [
                {
                    key: 'newsletter',
                    value: ['include']
                }
            ]
        }
        apiHelpers
            .apiRequest(endpoint, body, "POST", true, token)
            .then((res) => {
                if (res.success && res.code == 'story_found') {

                    let newsletters = [];
                    let longforms = [];
                    res.data.story.forEach(function(story_item){
                        if(story_item.newsletter){
                            newsletters.push(story_item)
                        }
                        else{
                            longforms.push(story_item)
                        }
                    })
                    let recent_stories = [...newsletters, ...longforms];
                    this.setState({
                        data:recent_stories.slice(0,3),
                       pageLoader:false,
                    })
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    showErrorModal: true,
                    pageLoader: false
                });
                console.log('Error=>> down', JSON.stringify(error));
            });
    }
    viewMoreArticles = () => {
        const { viewAllArticles } = this.props;
        viewAllArticles()
    }

    viewArticle = (catSlug, slug, postData) => {
        const { viewArticle } = this.props;
        viewArticle(catSlug, slug, postData)
    }

    viewAuthor = (slug) => {
        const { viewAuthor } = this.props;
        viewAuthor(slug)
    }
    viewCategory = (slug) => {
        const { viewCategory } = this.props;
        viewCategory(slug)
    }

    // signUp = () => {
    //     const { email } = this.state;
    //     this.setState({
    //         btnLoader: true,
    //         referralMsg: {
    //             enable: false,
    //             type: '',
    //             msg: ''
    //         }
    //     });

    //     this.setState({
    //         btnLoader: false
    //     });
    //     try {
    //         if (this.props.trackSignUp) {
    //             this.props.trackSignUp(email, 'mid banner');
    //         }
    //     }
    //     catch (error) {
    //         console.log("mix panel track error ==>", error);
    //     }
    //     if (helpers.isWeb()) {
    //         this.props.navigateWeb(`/sign-up?redirect=/starter-collection&email=${email}`)
    //     } else {
    //         this.props.navigateApp('/sign-up', { redirect: '/starter-collection', verifyRedirect: '/starter-collection', email: email });
    //     }
    // }

    
    handleClick = (title, data, index) => {
        try {
            if (this.props.trackStoryClick) {
                this.props.trackStoryClick(title, data, index);
            }
        }
        catch (error) {
            console.log("check mix panel track error ==>", error);
        }
    }   

    render() {
        let { data } = this.state;
        const { darkMode } = this.props;
        let webView = helpers.isWeb();
        let btnClick, btnClickCategory;

        if (helpers.isWeb()) {
            btnClick = {
                to: "/archive"
            };

        } else {
            btnClick = {
                onPress: () => this.viewMoreArticles()
            }
        }
        return (
            <View style={{ marginTop: helpers.isDesktop() ? 30 : 0 , paddingBottom: helpers.isDesktop() ? 100 : 10 }}>
                <View style={[Padding.ph_2, Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWebFull, helpers.isDesktop() && { marginTop: 70 }]}>
                    <View style={[Margin.mt_1, Margin.mb_4]}>
                        {helpers.isDesktop() ?
                            <View style={[Flex.row, Flex.justfiyCenter]}>
                                {data && data.map((item, index) => {
                                    var categorycolor = (item.category.name === "Internent") ? "#FC876D"
                                        : (item.category.name === "Business") ? "#2CB680"
                                            : "#907CFF"
                                    if (helpers.isWeb()) {
                                        btnClickCategory = {
                                            to: "/category/" + item.category.slug
                                        }
                                    } else {
                                        btnClickCategory = {
                                            onPress: () => this.viewCategory(item.category.slug)
                                        }
                                    }
                                    return (
                                        <View style={[articleItem.col4, helpers.isDesktop() && articleItem.col4Desktop, { marginRight: 40 }, { width: helpers.isDesktop() ? '31%' : '100%' }, (index == 2) && { marginRight: 0 }]}>
                                            <ArticleItemHorizontal viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} data={item} single={index == 0 ? true : false} homepage={true} handleClick={(title) => { this.handleClick(title, item, index) }} hideDate={true} darkMode={darkMode} homeRecentEdition={true} />
                                        </View>
                                    )
                                })}
                            </View>
                            :
                            <ScrollContainerView horizontal={true} showsHorizontalScrollIndicator={false}>
                                <View style={[Flex.row,Padding.pt_4, Margin.mb_1, !process.browser && { overflow: 'hidden' },!helpers.isDesktop() && { marginTop: 10 }]}>
                                    {data && data.map((item, index) => {
                                        if (helpers.isWeb()) {
                                            btnClickCategory = {
                                                to: "/category/" + item.category.slug
                                            }
                                        } else {
                                            btnClickCategory = {
                                                onPress: () => this.viewCategory(item.category.slug)
                                            }
                                        }

                                        var categorycolor = (item.category.name === "Internent") ? "#FC876D"
                                            : (item.category.name === "Business") ? "#2CB680"
                                                : "#907CFF"
                                        return (
                                            <View style={[articleItem.col3, helpers.isDesktop() && articleItem.col3Desktop,  !webView && { width: windowWidth - 100, marginRight: -20 }, (!webView && (index != 0)) && { marginLeft: 40 }]}>
                                               
                                                <ArticleItemHorizontal viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} data={item} single={index == 0 ? true : false} homepage={true} handleClick={(title) => { this.handleClick(title, item, index) }} hideDate={true} darkMode={darkMode} />
                                            </View>
                                        )
                                    })}
                                    <View style={{ marginRight: 20, width: 1 }}>
                                    </View>
                                    
                                </View>
                            </ScrollContainerView>
                        }
                        
                    </View>
                </View>
            </View>
        );
    }
}

export default AuthenticationWrapper(HomeRecentEdition);
